import React, { useState, useEffect, useRef, useContext, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import ImageComponent from 'atoms/Image';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import SEARCH_STORE_CONSTANTS from 'organisms/SearchStore/AU/Constants/SearchStoreConstants';
import { UserOrderContext } from 'context/context';
import { ConfirmSearchAddress } from '../Presentation/ConfirmSearchAddress';
import { SignInAndCurrentLocationSection } from '../Presentation/SignInAndCurrentLocationSection';
import { localisationStartAnalytics } from 'common/utilities/analyticsUtils';
import {
  checkTenantFunctions,
  getLocalStorage as isAddressAlreadySearched,
  setLocalStorage,
  getCurrentLocationGlobal,
} from '../Presentation/DispositionModuleUtils/DispositionModuleUtils';
import {
  addressSuggestionLengthMatch,
  getValueOrDefaultObject,
  isCateringDisposition,
  recursiveAndCheck,
  recursiveOrCheck,
  setDropOffAddress,
  getTernaryValue,
  getAndCheckIfOneTrue,
} from 'common/utilities/utils';
import { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import { LocationWarningForm } from '../Presentation/LocationWarningForm';
import UnitNumber from '../Presentation/UnitNumber';
import InlineErrors from '../Presentation/InlineErrors';
import SearchErrors from '../Presentation/SearchErrors';
import SharedConstants, {
  PLACE_SERVICE_ERROR_CODE,
  DISPOSITION_KEYS,
  ROUTE_URL,
  LOCAL_STORAGE_KEYS,
  ZERO_RESULTS,
  SUB_PREMISE_FILTER,
} from 'common/constants/SharedConstants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import SavedAddressView from '../Presentation/SavedAddressView';
import KfcNearYouTextSection from '../Presentation/KfcNearYouTextSection';
import SearchStoreCardDynamic from '../Presentation/SearchStoreCardDynamic';
import {
  sortStoresForDisplay,
  typeOfViewText,
  handleSkipStoresListScreen,
  getAddressTempValue,
  autoFillAddress,
  checkForZeroSuggestions,
  typeOfClosedStoresError,
  checkLocationAccess,
  getLocationAccessStatus,
  getSearchStoreGlobalCall,
  modifyLocationError,
  localisationErrorAnalytic,
  onEnterCloseKeyboard,
  populateFirstSuggestion,
  getUnitValue,
  getStreetNumber,
  localisationViewAnalyticsData,
} from '../SearchStoreUtilities/SearchStoreUtils';
import { FORM, searchStoreConfig, STORES } from 'organisms/SearchStore/AU/Config/searchStore.config';
import { useHistory } from 'react-router-dom';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { ChannelManager } from 'common/manager';
import MapContainer from './MapContainer';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { useAppDispatch, useAppSelector } from '@kfc-global/react-shared/redux/Store/hooks';
import { getPWAstorage, setPWAstorage, resetPWAstorage } from '@kfc-global/react-shared/redux/Slices/PwaStorageSlice';
import CONTEXT_REDUCER_MAPPING_KEY from 'common/constants/ContextReducerKeys';

const { CATERING_PAGE, MENU_PAGE } = ROUTE_URL;
const { Error_Yellow } = IMAGE_PATH;
const { RETAIN_ADDRESS, CONFIG_SEARCH_SCREEN } = LOCAL_STORAGE_KEYS;
const { SEARCH_ORDER_DATA, DISPOSITION_METHOD, REORDER_MODAL_OPEN, REORDER_STORE_CHANGED } = START_ORDER_CONSTANTS;
const {
  MIN_SEARCH_CHARACTER_LIMIT,
  SET_LOCATION_BUTTON_FLAG,
  SELECTED_FAV_ADDRESS,
  FORMATTED_DELIVERY_ADDRESS,
  SELECTED_LINE_ADDRESS_VAL,
  IS_FAV_ADDRESS_SELECTED,
  STREET_NUMBER,
  NON_FORMATTED_ADDRESS,
} = SEARCH_STORE_CONSTANTS;
const {
  RETRY_BTN_TEXT,
  VIEW_MAP_BTN_TEXT,
  ADDRESS_NOT_FOUND_ERROR,
  GOOGLE_API_ERROR,
  LOCATION_BLOCKED_ERROR,
  KFC_URL,
} = TRANSLATE_MAPPING_KEY;
const {
  KEY_CHAR_CODE: { ENTER },
} = SharedConstants;
const { SET_LOCATION_INFO } = CONTEXT_REDUCER_MAPPING_KEY;

let googleApiErrorEventFire = false;

export const eligibleStoreList = ({
  orderSummaryModalClose,
  eligibleStoresForList,
  loggedIn,
  onClickMapHandler,
  storeOpenBtnText,
  findAKFC,
  storeNumberFormat,
}) => {
  return (
    <>
      {orderSummaryModalClose &&
        eligibleStoresForList?.map(store => (
          <SearchStoreCardDynamic
            key={store?.id}
            store={store}
            loggedIn={loggedIn}
            onClickMapHandler={onClickMapHandler}
            storeOpenBtnText={storeOpenBtnText}
            findAKFC={findAKFC}
            storeNumberFormat={storeNumberFormat}
          />
        ))}
    </>
  );
};

const SearchStore = props => {
  const {
    userPositionHandler,
    eligibleStoreData,
    dispositionType,
    seteligibleStoreData,
    storeSelection,
    formContent,
    eligibleFavoriteStoreData,
    findAKFC,
    finAKFCContentData = {},
    isMobile,
  } = props;

  const inputRef = useRef(null);
  const history = useHistory();
  const dispatch = useAppDispatch();
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const {
    searchStoreData,
    scheduleOrderData,
    setLocationClicked,
    showLocationConfirmModal,
    showNotInRadiusError,
    notInRadiusRestaurant,
    orderSummaryModalClose,
  } = userOrderState;
  const { configSearchScreen = localStorage.getItem(CONFIG_SEARCH_SCREEN) } = searchStoreData;
  const [address, setAddress] = useState('');
  const [showAutoSuggestion, setShowAutoSuggestion] = useState(false);
  const [suggestedAddress, setSuggestedAddress] = useState([]);
  const [showDeliveryAddressLine, setShowDeliveryAddressLine] = useState(false);
  const [locationWarning, setLocationWarning] = useState(false);
  const [backupAddress, setBackupAddress] = useState('');
  const [deliveryAddressLineVal, setDeliveryAddressLineVal] = useState('');
  const [errorObj, setErrorObj] = useState({});
  const [deliveryErrorObj, setDeliveryErrorObj] = useState({});
  const [showStores, setShowStores] = useState(false);
  const [isMapView, setMapView] = useState(false);
  const [selectedCoords, setSelectedCoords] = useState({});
  const [mapStoreId, setMapStoreId] = useState(null);
  const [addressSearch, setAddressSearch] = useState(false);
  const userParams = useSelector(data => data.appStateReducer.userStatus);
  const { loggedIn } = getValueOrDefaultObject(userParams);
  const { savedAddresses, favouriteStores } = useSelector(data => data?.profileReducer);
  const { componentOptions, storelocatormaxreturncount = 10 } = useSelector(data => data?.tenantReducer);
  const dispositionConfig = componentOptions?.web?.dispositionConfig;
  const storeNumberFormat = componentOptions?.web?.restaurantDetailPage?.storeNumberFormat;
  const autoSelectDeliveryStore = componentOptions?.web?.dispositionConfig?.autoSelectDeliveryStore;
  const shouldEnableConfirmButton =
    componentOptions?.web?.dispositionConfig?.DELIVERY_STORES?.shouldEnableConfirmButton;
  const apartmentDetailsRegex = componentOptions?.web?.dispositionConfig?.apartmentDetailsRegex;
  const changeAddressErrorMsgStyle = componentOptions?.web?.storeSearch?.changeAddressErrorMsgStyle;
  // Getting the config key to get the corresponding config as per selected disposition
  const configSearchKey = `${dispositionType}_${configSearchScreen}`;
  // Getting the config to change the page behavior as per selected disposition
  const {
    placeholder,
    shouldShowLocationWarning,
    shouldShowDeliveryAddressLine,
    shouldHandleKeyPress,
    serviceUnavailableError,
    shouldShowSingleStore,
    shouldShowSavedAddress,
    shouldShowStoresList,
    shouldShowKfcStoresCount,
    shouldShowMapListToggleLink,
    kfcStoresCountText,
    shouldShowLocationLink,
    shouldPopulateFirstSuggestion,
    storeOpenBtnText,
    filteredTypes,
    filterConditions,
  } = { ...searchStoreConfig?.[configSearchKey], ...dispositionConfig?.[configSearchKey] };
  const getPwaStorageData = useAppSelector(getPWAstorage);
  const { errMsg, firstBtnText, firstBtnHandler, secondBtnHandler, secondBtnText, firstBtnClassName } =
    serviceUnavailableError;
  /* fetching data from storesReducer */
  const isLoading = useSelector(state =>
    recursiveOrCheck(
      state.storesReducer?.isGoogleDistanceLoading,
      state.storesReducer?.isStoreStatusLoading,
      state.storesReducer?.isFavoriteStoreStatusLoading,
      state.storesReducer?.isNearByStoresLoading,
    ),
  );
  const onClickMapHandlerDelivery = () => {
    setErrorObj({});
    setMapView(true);
  };
  /* Called when retry button is clicked */
  const onRetryClickHandler = useCallback(() => {
    setErrorObj({});
    setDeliveryErrorObj({});
    setLocationWarning(false);
    inputRef?.current?.select();
  }, []);

  useEffect(() => {
    getPwaStorageData?.selectedLineValueAddress &&
      setDeliveryAddressLineVal(getPwaStorageData?.selectedLineValueAddress);
  }, [getPwaStorageData]);

  /* keypress handler to control the handleSelect if there are no suggestions */
  /* istanbul ignore next */
  const keyPressSearch = useCallback(
    event => {
      onEnterCloseKeyboard(shouldHandleKeyPress, event?.keyCode === ENTER, inputRef, userOrderStateDispatch);
      const errorWithNoSuggestions = recursiveAndCheck(
        shouldHandleKeyPress,
        event?.keyCode === ENTER,
        !suggestedAddress?.length,
      );
      populateFirstSuggestion(
        shouldPopulateFirstSuggestion,
        event?.keyCode === ENTER,
        suggestedAddress,
        setAddress,
        address,
      );
      let deliveryKeyPressNoSuggestionErr = {
        showError: errorWithNoSuggestions,
        errMsg: translateWithI18Next(ADDRESS_NOT_FOUND_ERROR),
        errDesc: null,
        firstBtnText: translateWithI18Next(RETRY_BTN_TEXT),
        secondBtnText: translateWithI18Next(VIEW_MAP_BTN_TEXT),
        firstBtnCTA: onRetryClickHandler,
        secondBtnCTA: onClickMapHandlerDelivery,
      };
      let pickupKeyPressNoSuggestionErr = {
        showError: errorWithNoSuggestions,
        errMsg: translateWithI18Next(errMsg),
        errDesc: null,
        firstBtnText: translateWithI18Next(firstBtnText),
        secondBtnText: translateWithI18Next(secondBtnText),
        firstBtnCTA: functionObject?.[firstBtnHandler],
        secondBtnCTA: functionObject?.[secondBtnHandler],
        firstBtnClassName: firstBtnClassName,
      };
      let dispositionSpecificErr = getTernaryValue(
        dispositionType?.toUpperCase() === DISPOSITION_KEYS.DELIVERY,
        deliveryKeyPressNoSuggestionErr,
        pickupKeyPressNoSuggestionErr,
      );
      !errorObj?.showError && setErrorObj(dispositionSpecificErr);
      deliveryKeyPressNoSuggestionErr?.showError
        ? !deliveryErrorObj?.showError && setDeliveryErrorObj(deliveryKeyPressNoSuggestionErr)
        : setDeliveryErrorObj({});
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [
      errorObj?.showError,
      deliveryErrorObj?.showError,
      onRetryClickHandler,
      shouldHandleKeyPress,
      suggestedAddress?.length,
    ],
  );
  /* called when user address needs to be selected */
  const handleSelectAddressGlobal = useCallback(
    async (value, placeId) => {
      const addressTemp = getAddressTempValue(placeId, shouldHandleKeyPress, suggestedAddress, value, dispositionType);
      setBackupAddress(addressTemp);
      setAddress(value);
      setAddressSearch(true);
      setLocalStorage(addressTemp);
      const results = await geocodeByAddress(addressTemp);
      const getUpdateAptNumber = SUB_PREMISE_FILTER?.some(term => addressTemp.includes(term));
      setDropOffAddress(dispositionType, results);
      const latLong = await getLatLng(results[0]);
      userPositionHandler({ userLat: latLong.lat, userLong: latLong.lng });
      setSelectedCoords(latLong);
      if (getUpdateAptNumber) {
        dispatch(
          setPWAstorage({ key: SEARCH_STORE_CONSTANTS?.SELECTED_LINE_ADDRESS_VAL, value: getUnitValue(addressTemp) }),
        );
        setDeliveryAddressLineVal(getUnitValue(addressTemp));
        dispatch(
          setPWAstorage({ key: FORMATTED_DELIVERY_ADDRESS, value: value.replace(`${getUnitValue(addressTemp)},`, '') }),
        );
      }
      dispatch(setPWAstorage({ key: NON_FORMATTED_ADDRESS, value: value }));
      dispatch(setPWAstorage({ key: STREET_NUMBER, value: getStreetNumber(results)?.long_name }));
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [shouldHandleKeyPress, suggestedAddress, userPositionHandler, dispositionType],
  );

  /* called when use this address button from Location warning is clicked */
  const onUseThisAddressHandlerGlobal = useCallback(() => {
    setLocationWarning(false);
    setShowDeliveryAddressLine(shouldShowDeliveryAddressLine);
    setAddress(backupAddress);
  }, [backupAddress, shouldShowDeliveryAddressLine]);

  /* Handler for deciding whether to show the list of store cards or directly go to order mode screen*/
  const shouldSkipStoresListScreen = useCallback(
    eligibleStores => {
      handleSkipStoresListScreen(
        eligibleStores,
        shouldShowSingleStore,
        address,
        deliveryAddressLineVal,
        setShowStores,
        isMapView,
        userOrderStateDispatch,
        userOrderState,
        autoSelectDeliveryStore,
        dispositionType,
      );
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [address, isMapView, shouldShowSingleStore, deliveryAddressLineVal, userOrderStateDispatch],
  );

  /* called when unit number confirm button is clicked */
  const confirmDeliveryAddressLineHandler = useCallback(() => {
    userOrderStateDispatch({
      type: SEARCH_ORDER_DATA,
      value: { showSearchStore: true, configSearchScreen: STORES },
    });
    localStorage.setItem(CONFIG_SEARCH_SCREEN, STORES);
    setShowDeliveryAddressLine(false);
    !findAKFC && shouldSkipStoresListScreen(eligibleStoreData);
    getAndCheckIfOneTrue(findAKFC, isMapView) && autoPressEnter(inputRef);
    getAndCheckIfOneTrue(findAKFC, isMapView) && autoPressEnter(inputRef);
    userOrderStateDispatch({
      type: SET_LOCATION_INFO,
      value: { selectedDeliveryAddress: address, deliveryAddressLineVal },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eligibleStoreData, shouldSkipStoresListScreen, userOrderStateDispatch]);

  /* called when user wants to clear entire address in places autocomplete input box*/
  const onClearTextHandler = useCallback(() => {
    userOrderStateDispatch({
      type: SEARCH_ORDER_DATA,
      value: { showSearchStore: true, configSearchScreen: FORM },
    });
    localStorage.setItem(LOCAL_STORAGE_KEYS.CONFIG_SEARCH_SCREEN, FORM);
    setAddress('');
    setLocationWarning(false);
    setShowDeliveryAddressLine(false);
    setErrorObj({});
    setDeliveryErrorObj({});
    setShowStores(false);
    setMapView(false);
    inputRef?.current?.focus();
    setMapStoreId(null);
    setAddressSearch(false);
    dispatch(resetPWAstorage({ key: FORMATTED_DELIVERY_ADDRESS }));
    dispatch(resetPWAstorage({ key: SELECTED_FAV_ADDRESS }));
    dispatch(resetPWAstorage({ key: SELECTED_LINE_ADDRESS_VAL }));
    dispatch(resetPWAstorage({ key: IS_FAV_ADDRESS_SELECTED }));
    setDeliveryAddressLineVal('');
    // seteligibleStoreData([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [seteligibleStoreData]);

  /* input value onchange event */
  const onInputChange = useCallback(
    value => {
      setErrorObj({});
      setDeliveryErrorObj({});
      setLocationWarning(false);
      setShowDeliveryAddressLine(false);
      value ? setAddress(value) : onClearTextHandler();
      setMapStoreId(null);
    },
    [onClearTextHandler],
  );

  /* JSON object of a list of functions to dynamically execute a function based on key got from page config */
  const functionObject = useMemo(
    () => ({
      focusInputBox: () => {
        inputRef.current.select();
        setErrorObj({});
        setDeliveryErrorObj({});
      },
      gotoMenuPage: () => {
        history.push({ pathname: getTernaryValue(isCateringDisposition(dispositionType), CATERING_PAGE, MENU_PAGE) });
        userOrderStateDispatch({ type: SEARCH_ORDER_DATA, value: { showSearchStore: false } });
      },
      switchToPickup: () => {
        userOrderStateDispatch({
          type: DISPOSITION_METHOD,
          value: { dispositionType: DISPOSITION_KEYS.PICKUP },
        });
        userOrderStateDispatch({
          type: SEARCH_ORDER_DATA,
          value: { showSearchStore: true, configSearchScreen: FORM },
        });
        localStorage.setItem(CONFIG_SEARCH_SCREEN, FORM);
        onClearTextHandler();
      },
      openDeliveryAddressScreen: () => {
        userOrderStateDispatch({
          type: SEARCH_ORDER_DATA,
          value: { showSearchStore: true, configSearchScreen: FORM },
        });
        localStorage.setItem(CONFIG_SEARCH_SCREEN, FORM);
        userOrderStateDispatch({
          type: DISPOSITION_METHOD,
          value: { dispositionType: DISPOSITION_KEYS.DELIVERY },
        });
        inputRef.current.select();
        setErrorObj({});
        setDeliveryErrorObj({});
      },
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [history, onClearTextHandler, userOrderStateDispatch],
  );

  const checkShouldSkipStoresListScreen = useCallback(
    storesData => {
      if (!shouldShowLocationWarning) {
        shouldSkipStoresListScreen(storesData);
      }
    },
    [shouldShowLocationWarning, shouldSkipStoresListScreen],
  );

  /* called when eligible stores data changes */
  const onAddressSelectionGlobal = useCallback(
    (storesData, loading, addressBackup, favoriteStoresData) => {
      if (storesData?.length > 0) {
        setErrorObj({});
        setDeliveryErrorObj({});
        setLocationWarning(shouldShowLocationWarning);
        checkShouldSkipStoresListScreen(storesData);
      } else if (
        recursiveAndCheck(
          favoriteStoresData?.length,
          address,
          dispositionType?.toUpperCase() !== DISPOSITION_KEYS.DELIVERY,
        )
      ) {
        setErrorObj({});
        setDeliveryErrorObj({});
        seteligibleStoreData(favoriteStoresData);
      } else {
        let zeroSuggestionStoreClose = recursiveAndCheck(
          address !== backupAddress,
          shouldHandleKeyPress,
          dispositionType?.toUpperCase() === DISPOSITION_KEYS.DELIVERY,
        );
        let zeroSuggestionStoreCloseTrue = {
          showError: shouldHandleKeyPress,
          errMsg: translateWithI18Next(ADDRESS_NOT_FOUND_ERROR),
          errDesc: null,
          firstBtnText: translateWithI18Next(RETRY_BTN_TEXT),
          secondBtnText: translateWithI18Next(VIEW_MAP_BTN_TEXT),
          firstBtnCTA: onRetryClickHandler,
          secondBtnCTA: onClickMapHandlerDelivery,
        };

        let zeroSuggestionStoreCloseFalse = {
          showError: recursiveAndCheck(!loading, addressBackup),
          errMsg: translateWithI18Next(errMsg),
          errDesc: null,
          firstBtnText: translateWithI18Next(firstBtnText),
          secondBtnText: translateWithI18Next(secondBtnText),
          firstBtnCTA: functionObject?.[firstBtnHandler],
          secondBtnCTA: functionObject?.[secondBtnHandler],
          firstBtnClassName: firstBtnClassName,
        };
        typeOfClosedStoresError(
          zeroSuggestionStoreClose,
          zeroSuggestionStoreCloseTrue,
          zeroSuggestionStoreCloseFalse,
          setErrorObj,
        );
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      checkShouldSkipStoresListScreen,
      functionObject,
      serviceUnavailableError,
      shouldShowLocationWarning,
      address,
      dispositionType,
    ],
  );

  /* check which handleSelect function to be called based on tenant */
  const { handleSelectAddress, onUseThisAddressHandler, callOnAddressConfirmHandler } = checkTenantFunctions({
    handleSelectAddressGlobal,
    onUseThisAddressHandlerGlobal,
    onAddressSelectionGlobal,
  });

  /* Function for fetching current user location */
  const getCurrentLocation = useCallback(async () => {
    localisationStartAnalytics();
    const results = await getCurrentLocationGlobal(userOrderStateDispatch);
    if (results) {
      setBackupAddress(ChannelManager.address);
      setAddress(ChannelManager.address);
      setLocalStorage(ChannelManager.address);
      setSuggestedAddress([{ description: ChannelManager.address }]);
      const { longitude, latitude } = ChannelManager.coordinates;
      let resultArr = await geocodeByAddress(ChannelManager.address);
      setDropOffAddress(dispositionType, resultArr);
      userPositionHandler({ userLat: latitude, userLong: longitude });
      setSelectedCoords({ lat: latitude, lng: longitude });
    }
    getLocationAccessStatus(userOrderStateDispatch, !results);
  }, [userOrderStateDispatch, userPositionHandler, dispositionType]);

  /* Error handler for PlacesAutoComplete */
  const onSearchError = useCallback(
    status => {
      checkForZeroSuggestions(status, ZERO_RESULTS, setSuggestedAddress);
      const shouldShowError = PLACE_SERVICE_ERROR_CODE.includes(status);
      setErrorObj({
        showError: shouldShowError,
        errMsg: translateWithI18Next(GOOGLE_API_ERROR),
        errDesc: null,
        firstBtnText: translateWithI18Next(RETRY_BTN_TEXT),
        secondBtnText: null,
        firstBtnCTA: onRetryClickHandler,
        secondBtnCTA: null,
      });
    },
    [onRetryClickHandler],
  );

  /* called when user clicks on set location button in home page banner */
  useEffect(() => {
    if (setLocationClicked) {
      let getUserLocation = async () => {
        await getCurrentLocation();
      };
      getUserLocation();
      userOrderStateDispatch({ type: SET_LOCATION_BUTTON_FLAG, value: { setLocationClicked: false } });
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setLocationClicked]);

  useEffect(() => {
    const fireGoogleApiErrorAnalytic = errorObj?.errMsg === translateWithI18Next(GOOGLE_API_ERROR);
    localisationErrorAnalytic(fireGoogleApiErrorAnalytic, googleApiErrorEventFire);
    if (fireGoogleApiErrorAnalytic) {
      googleApiErrorEventFire = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorObj?.showError]);

  /* called when there is a change in address in places autocomplete input box */
  useEffect(() => {
    const autoSuggestionCondition = addressSuggestionLengthMatch(address, MIN_SEARCH_CHARACTER_LIMIT);
    setShowAutoSuggestion(autoSuggestionCondition);
  }, [address]);

  /* Called on mount to focus on input box and auto filling with the latest search results after localisation */
  useEffect(() => {
    if (!findAKFC) {
      inputRef?.current?.focus();
      const retainAddress = localStorage?.getItem(RETAIN_ADDRESS);
      autoFillAddress(
        scheduleOrderData,
        searchStoreData,
        suggestedAddress,
        setSuggestedAddress,
        handleSelectAddress,
        retainAddress,
        address,
      );
    }
    setMapView(false);

    // eslint-disable-next-line
  }, [configSearchScreen, findAKFC]);

  useEffect(() => {
    checkLocationAccess(userOrderStateDispatch, showLocationConfirmModal);
    // eslint-disable-next-line
  }, [userOrderStateDispatch]);

  /* called when there is a change in eligibleStoreData */
  useEffect(() => {
    callOnAddressConfirmHandler(eligibleStoreData, isLoading, backupAddress, eligibleFavoriteStoreData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eligibleStoreData, isLoading, backupAddress, eligibleFavoriteStoreData]);

  const passAddress = (addr, latlng) => {
    onInputChange(addr);
    setSuggestedAddress([{ description: addr }]);
    setSelectedCoords(latlng);
    inputRef?.current?.focus();
    if (isMapView) {
      autoPressEnter(inputRef);
    }
  };
  /* called when user moves the map red marker and selects the address */
  const autoPressEnter = inputBox => {
    let ev = new KeyboardEvent('keydown', {
      altKey: false,
      bubbles: true,
      cancelBubble: false,
      cancelable: true,
      charCode: 0,
      code: 'Enter',
      composed: true,
      ctrlKey: false,
      currentTarget: null,
      defaultPrevented: true,
      detail: 0,
      eventPhase: 0,
      isComposing: false,
      isTrusted: true,
      key: 'Enter',
      keyCode: 13,
      location: 0,
      metaKey: false,
      repeat: false,
      returnValue: false,
      shiftKey: false,
      type: 'keydown',
      which: 13,
    });

    inputBox?.current?.dispatchEvent(ev);
  };
  /* called when user clicks on Map link in store card */
  const onClickMapHandler = useCallback(storeId => {
    setMapView(true);
    setShowStores(false);
    setMapStoreId(storeId);
  }, []);

  /* toggle between List & Map view */
  const toggleView = useCallback(() => {
    setShowStores(isMapView);
    setMapView(!isMapView);
    localisationViewAnalyticsData(isMapView, dispositionType);
  }, [isMapView]);

  const showSavedAddressView = recursiveAndCheck(
    savedAddresses?.length,
    loggedIn,
    shouldShowSavedAddress,
    !locationWarning,
    !showDeliveryAddressLine,
    !errorObj?.showError,
  );
  const showLocationWarningForm = recursiveAndCheck(
    locationWarning,
    suggestedAddress?.length,
    eligibleStoreData?.length,
  );
  const showSearchErrors = recursiveAndCheck(errorObj?.showError, !isLoading, address);
  const showLocationError = recursiveAndCheck(showLocationConfirmModal, shouldShowLocationLink, !isMapView);
  const eligibleStoresForMap = sortStoresForDisplay(
    eligibleStoreData,
    favouriteStores,
    storelocatormaxreturncount,
    !errorObj?.showError,
    true,
  );
  const showError = recursiveOrCheck(
    errorObj?.showError,
    showLocationError,
    showNotInRadiusError,
    showLocationWarningForm,
    showSearchErrors,
    showDeliveryAddressLine,
  );
  const showKfcCount = recursiveAndCheck(
    shouldShowKfcStoresCount,
    eligibleStoreData?.length > 0,
    !isLoading,
    addressSearch,
    !showError,
  );
  const showMapLink = recursiveAndCheck(
    address,
    eligibleStoreData?.length > 0,
    shouldShowMapListToggleLink,
    !isLoading,
    addressSearch,
    !showError,
  );
  const eligibleStoresForList = sortStoresForDisplay(
    eligibleStoreData,
    favouriteStores,
    storelocatormaxreturncount,
    recursiveAndCheck(showStores, !errorObj?.showError),
    shouldShowStoresList,
  );

  const setEligibleStoresMap = deliveryErrorObj?.showError ? [] : eligibleStoresForMap;
  const kfcCount = isMapView ? eligibleStoresForMap?.length : eligibleStoresForList?.length;
  const showHideLocation = recursiveOrCheck(isMapView, !shouldShowLocationLink);
  const showStoreCard = recursiveAndCheck(kfcCount, !isMapView, addressSearch);
  const showContainer = recursiveOrCheck(showError, showKfcCount, isMapView);
  const showImage = recursiveAndCheck(findAKFC, !showContainer, !showStoreCard);
  return (
    <div
      className={
        findAKFC
          ? `${getTernaryValue(showContainer, 'findkfc-delivery-show-container', 'findkfc-delivery-hide-container')} ${
              showError && 'findkfc-delivery-error-container'
            } ${getTernaryValue(isMapView, 'mapview', 'listview')}`
          : 'selectkfc-delivery-container'
      }
      data-testid='delivery-container'
    >
      <div className='delivery-module-form search-store-global' data-testid='delivery-component'>
        <div id='search-store-global-content' className={getSearchStoreGlobalCall(showLocationConfirmModal)}>
          <InlineErrors
            show={showLocationError}
            errorMsg={modifyLocationError(LOCATION_BLOCKED_ERROR, KFC_URL)}
            errImage={Error_Yellow}
            cssClass='location-blocked'
          />
          <div
            className={getTernaryValue(findAKFC, 'findkfc-search-store-container', 'selectkfc-search-store-container')}
          >
            <SignInAndCurrentLocationSection
              loggedIn={loggedIn}
              formContent={formContent}
              storeSelection={storeSelection}
              useCurrentLocation={getCurrentLocation}
              hideLocationLink={showHideLocation}
              showLocationConfirmModal={showLocationConfirmModal}
            />
            <ConfirmSearchAddress
              {...props}
              storeSelection={storeSelection}
              history={history}
              inputOnChange={onInputChange}
              address={address}
              showAutoSuggestion={showAutoSuggestion}
              setSuggestedAddress={setSuggestedAddress}
              handleSelectAddress={handleSelectAddress}
              alreadySearched={isAddressAlreadySearched}
              onClearTextHandler={onClearTextHandler}
              keyPress={keyPressSearch}
              inputRef={inputRef}
              onSearchError={onSearchError}
              placeholder={translateWithI18Next(placeholder)}
              filteredTypes={filteredTypes}
              filterConditions={filterConditions}
            />

            <div
              className={`${getTernaryValue(showNotInRadiusError, 'error-can-not-deliver', 'hide-error-container')}`}
            >
              <InlineErrors
                show={showNotInRadiusError}
                errorMsg={[
                  <span className='store-name'>{notInRadiusRestaurant} </span>,
                  translateWithI18Next(SEARCH_STORE_CONSTANTS.CAN_NOT_DELIVER_ERROR_MSG),
                ]}
                errImage={IMAGE_PATH.Error}
                cssClass='error-sub-container'
              />
            </div>
            <LocationWarningForm
              show={showLocationWarningForm}
              onRetryClickHandler={onRetryClickHandler}
              address={backupAddress}
              onUseThisAddressHandler={onUseThisAddressHandler}
              changeAddressErrorMsgStyle={changeAddressErrorMsgStyle}
            />
            <UnitNumber
              show={showDeliveryAddressLine}
              suggestedAddress={address}
              confirmDeliveryAddressLineHandler={confirmDeliveryAddressLineHandler}
              onChangeDeliveryAddressLine={setDeliveryAddressLineVal}
              deliveryAddressLineVal={deliveryAddressLineVal}
              shouldEnableConfirmButton={shouldEnableConfirmButton}
              apartmentDetailsRegex={apartmentDetailsRegex}
            />
            <SearchErrors show={showSearchErrors} errorObj={errorObj} />
            <SavedAddressView
              show={showSavedAddressView}
              savedAddresses={savedAddresses}
              handleSelectAddress={handleSelectAddress}
            />
            <KfcNearYouTextSection
              showKfcCount={showKfcCount}
              kfcCount={kfcCount}
              showMapLink={showMapLink}
              typeOfView={typeOfViewText(isMapView)}
              toggleView={toggleView}
              kfcStoresCountText={kfcStoresCountText}
            />
          </div>
          <div
            className={
              findAKFC
                ? `${getTernaryValue(showStoreCard, 'store-dynamic-card-container', 'store-no-card-container')}`
                : 'selectkfc-card-container'
            }
          >
            {showImage && (
              <ImageComponent
                srcFile={isMobile ? finAKFCContentData.mobileImage : finAKFCContentData.desktopImage}
                className='findkfc-img'
              />
            )}
            {eligibleStoreList({
              orderSummaryModalClose,
              eligibleStoresForList,
              loggedIn,
              onClickMapHandler,
              storeOpenBtnText,
              findAKFC,
              storeNumberFormat,
            })}
          </div>
        </div>
        {isMapView ? (
          <MapContainer
            eligibleStores={setEligibleStoresMap}
            selectedStoreId={mapStoreId}
            loggedIn={loggedIn}
            selectedCoords={selectedCoords}
            passAddress={passAddress}
            configSearchKey={configSearchKey}
            useCurrentLocation={getCurrentLocation}
            showLocationConfirmModal={showLocationConfirmModal}
            findAKFC={findAKFC}
          />
        ) : null}
      </div>
    </div>
  );
};
export default SearchStore;
